var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 46.4c3.556-2.735 7.697-3.281 11.937-3.281 9.026 0 17.368 7.385 17.368 16.41H52.4M27.607 14.4c6.838 0 12.308 5.47 12.308 12.308s-5.47 12.308-12.308 12.308A12.257 12.257 0 0 1 15.3 26.708c0-6.838 5.47-12.308 12.308-12.308zM56.326 17.135a9.514 9.514 0 0 1 9.573 9.573 9.514 9.514 0 0 1-9.573 9.573 9.514 9.514 0 0 1-9.573-9.573 9.514 9.514 0 0 1 9.573-9.573zM5.726 66.368c0-12.035 9.847-21.881 21.882-21.881 4.786 0 9.299 1.504 13.128 4.376.41.273.684.547 1.094.82.41.274.684.547.958.958 1.914 1.914 3.555 4.102 4.65 6.7 1.23 2.873 1.914 5.881 1.914 9.027H5.726z",
    stroke: "#003A70",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUsers);
export default __webpack_public_path__ + "static/media/icn_users.wtn-site.svg";
export { ForwardRef as ReactComponent };